import {Component, Inject, OnInit, AfterViewInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {Message} from "src/app/core/class/message";
import {ToastrService} from "ngx-toastr";
import {DocumentService} from "src/app/core/services/document.service";
import {NotificationService} from "src/app/core/services/notification.service";
import {WarningComponent} from "src/app/shared/components/warning/warning.component";
import {BehaviorSubject, Subscription} from "rxjs";
import {NgForm} from "@angular/forms";
import { Location } from '@angular/common';
import { ApproveDocumentListComponent } from '../sign-document/approve-document-list/approve-document-list.component';
import { ErrorCode } from 'src/app/core/constants/error-code';

@Component({
  selector: 'app-approval-document-component',
  templateUrl: './approval-document.component.html',
  styleUrls: ['./approval-document.component.scss']
})
export class ApprovalDocumentComponent implements OnInit {
  document = {
    id: 0,
    reason: ''
  };
  formChangesSubscription: Subscription;
  @ViewChild('f', {static: false}) ngForm: NgForm;
  public isFormChanging: boolean;
  private success: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private message: Message,
    private toastr: ToastrService,
    private documentService: DocumentService,
    private location: Location,
    public dialogRef: MatDialogRef<ApprovalDocumentComponent>,
    public notificationService: NotificationService,
  ) {
    this.document = data.document;
  }

  public actions = new BehaviorSubject<any>('');

  ngAfterViewInit() {
    this.formChangesSubscription = this.ngForm.form.valueChanges.subscribe(() => {
      if (this.ngForm.dirty) {
        this.isFormChanging = true;
      }
    });

    // Focus on textarea reason after load
    // There's a problem if not setTimeout it will focus on 'reason' then lost focus right after
    setTimeout(_ => document.getElementById('reason').focus(), 500);
  }

  ngOnInit() {
    this.notificationService.subscribeErrorService();

  }

  cancel() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '350px',
        data: 'messages.confirm_change_data'
      });
      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  approvalDocument() {
    console.log('this.document',this.document);
    if (window.location.pathname === '/home-enterprise/search-approval-waiting-document') {
      this.actions.next({type:ApproveDocumentListComponent.CONFIRM_ACTION_NON_CERTIFICATE, document: this.document});
    } else {
      this.documentService.approvalDocumentDigital(this.document).subscribe(rs => {
        if(rs.code === ErrorCode.NotPermissionWithContract) {
          this.toastr.error(rs.message);
          return;
        }
        this.success = true;
        this.toastr.success(this.message.getMessage('messages.approve_success'));
        this.dialogRef.close(true);
      });
    }
   
  }
}
